import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

const FaqTagInfo = ({ isTagInfoOpen, toggleTagInfoModal, name, description, objectType}) => {

  const handleClose = () => {
    toggleTagInfoModal();
  };


  return (
    <Modal size="lg" isOpen={isTagInfoOpen} backdrop="static">
      <AvForm className="needs-validation">
        <ModalHeader>Tags and Categories Information</ModalHeader>
        <ModalBody>
          <Row>
            <Col md="12">
              <FormGroup>
                <Label htmlFor="name">Name</Label>
                <AvField
                  name="name"
                  type="text"
                  className="form-control"
                  value={name}
                  id="name"
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label htmlFor="description">
                  Description
                </Label>
                <AvField
                  name="description"
                  type="text"
                  className="form-control"
                  value={description}
                  id="description"
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col md="12">
              <FormGroup>
                <Label htmlFor="objectType">
                  Type
                </Label>
                <AvField
                  name="objectType"
                  type="text"
                  className="form-control"
                  value={objectType}
                  id="objectType"
                  disabled={true}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            onClick={handleClose}
            color="light"
            className="waves-effect"
          >
            Close
          </Button>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

export default FaqTagInfo;
